export default [
    {
        path: "/",
        name: "index",
        component: () => import("@/views/Index"),
        meta: {
            layout: "base"
        }
    },

    {
        path: "/legal",
        name: "legal",
        component: () => import("@/views/Legal"),
        meta: {
            layout: "base"
        }
    },

    {
        path: "/about",
        name: "about",
        component: () => import("@/views/About"),
        meta: {
            layout: "base"
        }
    },

    {
        path: "/dashboard",
        name: "dashboard",
        component: () => import("@/views/Dashboard"),
        meta: {
            requiresAuth: true,
            layout: "base"
        }
    },

    {
        path: "/quran",
        name: "quranReader",
        component: () => import("@/views/modules/quran/QuranReader"),
        meta: {
            layout: "base"
        }
    },

    {
        path: "/quran/stats",
        name: "quranStats",
        component: () => import("@/views/modules/quran/QuranStats"),
        meta: {
            layout: "base"
        }
    },


    //khatms
    {
        path: "/khatm/:uid",
        name: "khatm",
        props: true,
        component: () => import("@/views/modules/khatms/Khatm"),
        meta: {            
            layout: "base"
        }
    },

    {
        path: "/my-khatms",
        name: "myKhatms",
        props: true,
        component: () => import("@/views/modules/khatms/MyKhatms"),
        meta: {
            requiresAuth: true,
            layout: "base"
        }
    },


    //counter

    {
        path: "/counter/:uid",
        name: "counter",
        props: true,
        component: () => import("@/views/modules/counters/Counter"),
        meta: {
            layout: "base"
        }
    },

    {
        path: "/my-counters",
        name: "myCounters",
        props: true,
        component: () => import("@/views/modules/counters/MyCounters"),
        meta: {
            requiresAuth: true,
            layout: "base"
        }
    },

    //tasbih
    {
        path: "/tasbih",
        name: "tasbih",
        component: () => import("@/views/modules/tasbih/Tasbih"),
        meta: {
            layout: "base"
        }
    },

    {
        path: "/qibla",
        name: "qiblaCompass",
        component: () => import("@/views/modules/qibla/QiblaCompass"),
        meta: {
            layout: "base"
        }
    },

    //daily deeds
    {
        path: "/daily-deeds",
        name: "dailyDeeds",
        component: () => import("@/views/modules/daily-deeds/DailyDeeds"),
        meta: {
            requiresAuth: true,
            layout: "base"
        }
    },

    //daily deeds public share
    {
        path: "/daily-deeds/:slug",
        name: "dailyDeedsShare",
        props: true,
        component: () => import("@/views/modules/daily-deeds/DailyDeedsShare"),
        meta: {
            layout: "base"
        }
    },

    {
        path: "/support",
        name: "support",
        component: () => import("@/views/Support"),
        meta: {
            layout: "base"
        }
    },

    
    {
        path: "/legal",
        name: "legal",
        component: () => import("@/views/Legal"),
        meta: {
            layout: "base"
        }
    },
    
    {
        path: "/update",
        name: "update",
        component: () => import("@/views/Update"),
        meta: {
            layout: "base"
        }
    },

 
    {
        path: "*",
        name: "404",
        component: () => import("@/views/Error"),
        meta: {
            layout: "base"
        }
    }
];
